import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule, MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MomentDateAdapter } from '../shared-module/custom-moment/moment-date-adapter';
import { CurrentUser } from '../shared-module/common/services/current-user.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TenantSettings } from '../shared-module/common/services/tenant-settings.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  imports: [],
  exports: [
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatMenuModule,
    MatCheckboxModule,
    MatRadioModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatTreeModule,
    ScrollingModule,
    MatSnackBarModule,
    OverlayModule
  ],
  providers: [
    {
      provide: MAT_TABS_CONFIG,
      useValue: { animationDuration: '0ms' }
    },
    {
      provide: MAT_DATE_FORMATS,
      deps: [CurrentUser],
      useFactory: (userSettingService: CurrentUser) => {
        return userSettingService.dateFormats;
      }
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [CurrentUser, TenantSettings]
    }
  ]
})
export class CustomMaterialModule { }

